import branch from 'branch-sdk'
import Bugsnag from '@bugsnag/js'
import config from '#config'

export const useBranch = () => {
  var options = { no_journeys: true }

  const initializeBranch = () => {
    if (!config.branchApiKey) {
      Bugsnag.leaveBreadcrumb('Branch API key is missing in the configuration.')
      return
    }
    branch.init(config.branchApiKey, options, (error) => {
      if (error) {
        Bugsnag.leaveBreadcrumb('Branch initialization failed')
      }
    })
  }
  const trackBranchEvent = (
    event: string,
    event_data_and_custom_data?: {},
    callback?: {}[],
  ) => {
    if (!event) return

    try {
      branch.logEvent(event, event_data_and_custom_data, callback)
    } catch (error) {
      Bugsnag.leaveBreadcrumb('Failed to send Branch event')
    }
  }

  return { initializeBranch, trackBranchEvent }
}
